// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar_root__hZkrK","nav":"Navbar_nav__kvCyG","navMenu":"Navbar_navMenu__O_Qsn","link":"Navbar_link__7kOg_","logo":"Navbar_logo__FRCg_"};